import React from 'react'
import { Stack, Text } from '@mantine/core'
import { useCountdown, useMediumScreen } from '@/hooks'
import { AIRDROP_CONFIG, STRIDE_CURRENCY } from '@/config'
import { useTaskStatusQuery } from '../queries'

const target = new Date(AIRDROP_CONFIG.endDate)

const AirdropInformation: React.FC = () => {
  const { days, hours, minutes } = useCountdown({ target })

  const { data: taskStatus } = useTaskStatusQuery()

  const { isMediumScreen } = useMediumScreen()

  if (taskStatus === null) {
    return null
  }

  if (taskStatus?.claim && taskStatus?.liquidStake && taskStatus?.claim) {
    return (
      <Stack spacing="xs">
        <Text inline={isMediumScreen} sx={(t) => ({ color: t.colors.gray[7] })}>
          Well done! You claimed all your {STRIDE_CURRENCY.coinDenom} for this season.
        </Text>

        <Text inline={isMediumScreen} sx={(t) => ({ color: t.colors.gray[7] })}>
          Time left in this season:{' '}
          <strong>
            {days} days, {hours} hours, {minutes} minutes
          </strong>
        </Text>
      </Stack>
    )
  }

  if (taskStatus?.claim) {
    return (
      <Stack spacing="xs">
        <Text inline={isMediumScreen} sx={(t) => ({ color: t.colors.gray[7] })}>
          Well done! Complete the other tasks to get more {STRIDE_CURRENCY.coinDenom}.
        </Text>

        <Text inline={isMediumScreen} sx={(t) => ({ color: t.colors.gray[7] })}>
          Time left in this season:{' '}
          <strong>
            {days} days, {hours} hours, {minutes} minutes
          </strong>
        </Text>
      </Stack>
    )
  }

  return (
    <Stack spacing="xs">
      <Text inline={isMediumScreen} sx={(t) => ({ color: t.colors.gray[7] })}>
        Start by claiming your first tokens for free!
      </Text>

      <Text inline={isMediumScreen} sx={(t) => ({ color: t.colors.gray[7] })}>
        Time left in this season:{' '}
        <strong>
          {days} days, {hours} hours, {minutes} minutes
        </strong>
      </Text>
    </Stack>
  )
}

export { AirdropInformation }
